import { ProductType } from 'src/types/global-types';

const ProductTypes = [
    ProductType.BundleProduct,
    ProductType.ConfigurableProduct,
    ProductType.ComingSoonConfigurableProduct,
    ProductType.SimpleProduct,
    ProductType.ComingSoonSimpleProduct,
    ProductType.DownloadableProduct,
    ProductType.GroupedProduct,
    ProductType.VirtualProduct,
];

export function isProductType(type?: string): type is ProductType {
    if (!type) {
        return false;
    }

    return ProductTypes.includes(type as ProductType);
}
